export default function initRatingScroll() {
    const targetScrollEl = $("#review-form");
    const headerElement = $('.main-nav-holder');
    let headerHeight = 0;

    function fixedHeaderHeightCalc(x) {
        if (x.matches) {
            headerHeight = 0;
            ratingHandler();
        } else {
            headerHeight = headerElement.outerHeight();
            ratingHandler();
        }
    }

    const x = window.matchMedia("(max-width: 1279px)")

    fixedHeaderHeightCalc(x);
    x.addEventListener("change", function() {
        fixedHeaderHeightCalc(x);
    });

    function ratingHandler() {
        $(".js-rating-trigger").each(function() {
            $(this).on("click", function(e) {
                e.preventDefault();
                const target = $(e.target).data('target');
                const targetLink = $(`a[href="#${target}"]`);
                
                if(targetLink && targetScrollEl) {
                    targetLink.trigger("click");
        
                    let timer = setTimeout(() => {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: targetScrollEl.offset().top - headerHeight
                        }, 500);
                        clearTimeout(timer);
                    }, 50);
                }
            });
        });
    }
}
